import {clsx} from 'clsx'

import {VALUES} from '../../constants/values'
import {TimelineDivider} from './TimelineDivider'
import styles from './TimelineRowBorder.module.css'

export type TimelineRowBorderProps = {
  children: React.ReactNode
  addDivider: boolean
  item: {
    __id: string
  }
  isMajor?: boolean
  isHighlighted?: boolean
  className?: string
  commentParams?: TimelineRowBorderCommentParams
  ref?: React.Ref<HTMLDivElement>
}

export type TimelineRowBorderCommentParams = {
  first: boolean
  last: boolean
  viewerDidAuthor?: boolean
}

export const TimelineRowBorder = ({ref, ...props}: TimelineRowBorderProps) => {
  const {children, addDivider, item, isMajor, isHighlighted, commentParams, className} = props

  const dataProps = {
    [VALUES.timeline.dataTimelineEventId]: item.__id,
    'data-highlighted-event': isHighlighted,
  }
  return (
    <div className={styles.Box}>
      {addDivider && <TimelineDivider id={item.__id} />}
      <div
        key={item.__id}
        {...dataProps}
        ref={ref}
        className={clsx(
          styles.shared,
          isMajor && styles.major,
          isMajor && commentParams?.viewerDidAuthor && styles.viewerDidAuthor,
          !isMajor && styles.default,
          isHighlighted && styles.highlighted,
          className,
        )}
        data-testid={`timeline-row-border-${item.__id}`}
      >
        {children}
      </div>
    </div>
  )
}
TimelineRowBorder.displayName = 'TimelineRowBorder'
